module.exports = __webpack_public_path__ + "img/emojis-blisser-dislike.8015ba77.png";